let storeConfig = {
  logo: 'https://lacampa.s3-ap-southeast-2.amazonaws.com/assets/Parrinos%2520Pizza%2520Horizontal%2520logo.svg',
  logoPath:
    'https://assets.nextorder.co/assets/Parrinos%2520Pizza%2520Horizontal%2520logo.svg',
  storeId: '45JKs9EFjHvimcXaheG2',
  restaurantId: 'Ya8cIru6GGG2A8DOKySQ',
  timeZone: 'Australia/Sydney',
  environment: 'production',
  release: 'x.x.x',
  cloudFunctionsUrl:
    'https://us-central1-next-order-prodenv.cloudfunctions.net',
  storeColorCode: '#e25a28',
  publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
  stores: [
    {
      logo: 'https://lacampa.s3-ap-southeast-2.amazonaws.com/assets/Parrinos%2520Pizza%2520Horizontal%2520logo.svg',
      storeId: '45JKs9EFjHvimcXaheG2',
      restaurantId: 'Ya8cIru6GGG2A8DOKySQ',
      baseUrl: 'https://miranda.parrinos-pizza.com.au',
      baseUrls: [
        'https://parrinos-pizza.nextorder.com.au',
        'https://miranda.parrinos-pizza.com.au',
      ],
      timeZone: 'Australia/Sydney',
      addressLocation: {
        lat: -34.0338395,
        long: 151.1021393,
      },
      name: 'Parrinos Pizza',
      type: 'Italian',
      address: '45 Kiora Rd, Miranda',
      city: 'Miranda',
      state: 'New South Wales',
      stateIdentifier: 'NSW',
      country: 'Australia',
      countryCode: '+61',
      countryIdentifier: 'AU',
      currency: '$',
      currencyHtml: '&#36;',
      currencyCode: 'AUD',
      phoneNumberDisplay: '+61295751000',
      phoneNumber: '+61295751000',
      environment: 'production',
      release: 'x.x.x',
      cloudFunctionsUrl:
        'https://us-central1-next-order-prodenv.cloudfunctions.net',
      storeColorCode: '#e25a28',
      storeSecondColorCode: '#5e7462',
      publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
      areaCode: '2228',
      area: 'Miranda',
    },
  ],
};

export default storeConfig;
